"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getValidCombination;

var _countBy = _interopRequireDefault(require("lodash/countBy"));

var _passwordRegex = require("./passwordRegex");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// Count array values. Returns an object.
// Example return value: { true: 3, false: 1 };
function getValidCombination(value) {
  return (0, _countBy["default"])([(0, _passwordRegex.containLowerCase)(value), (0, _passwordRegex.containUpperCase)(value), (0, _passwordRegex.containNumber)(value), (0, _passwordRegex.containSymbol)(value)]);
}